import React, { useState } from "react";
import { MdExpandLess, MdOutlineExpandMore } from "react-icons/md";
import { Link } from "react-router-dom";
import { Color } from "../../../../Utils/styles";
import Loading from "../../../Common/Loading";
function TwoSliders({ landingLoading }) {
  const [reacdMore, setReacdMore] = useState(false);
  if (landingLoading) {
    return (
      <section className="background-gray pb-3 pt-1">
        <div className="container">
          <div className="row">
            <Loading count={2} col={6} height={"520"} />
          </div>
        </div>
      </section>
    );
  }
  return (
    <section className="background-gray pb-3 pt-1 home-text-sec">
      <div className="container">
        <div className="overflow-auto">
          <div className="pt-4">
            <img
              src={window.origin + "/WebSide/assets/images/logo.png"}
              alt="nikotan | نیکوتن"
              width={"100px"}
            />
            <h2
              style={{
                fontSize: "15px",
                marginRight: "30px",
                marginTop: "5px",
              }}
            >
              رزرو استخر و پارک آبی، رزرو باشگاه بدنسازی، رزرو سالن های ورزشی
            </h2>
          </div>
          <img
            className="img"
            style={{
              width: "40%",
              maxWidth: "100%",
              display: "block",
              float: "left",
            }}
            src={window.origin + "/img/main/Flag.webp"}
            alt="nikotan | نیکوتن"
          />
          <p className="text-3 text-right mt-5" style={{ fontWeight: "400" }}>
            نیکوتن به عنوان جامع ترین سامانه معرفی، اطلاع رسانی و رزرو آنلاین
            استخر و پارک های آبی، رزرو باشگاه بدنسازی، رزرو سالن ورزشی و ثبت نام
            کلاس های ورزشی شناخته می شود.
          </p>
          <p className="mt-3" style={{ fontWeight: "400" }}>
            شما به راحتی از طریق نیکوتن می توانید شیفت ها و سانس های تمامی
            مجموعه های ورزشی کشور(استخر و پارک های آبی، باشگاه های بدنسازی، سالن
            های ورزشی و کلاس های ورزشی) را مشاهده کنید و به صورت آنلاین و با
            تخفیف های ویژه رزرو و ثبت نام نمایید. نیکوتن علاوه بر راه اندازی
            امکان رزرو آنلاین برای کاربران، برای مدیران مجموعه ها نیز پنل های
            کاملی را در نظر گرفته است که مدیران گرامی به صورت کاملا رایگان می
            توانند مجموعه ورزشی خود را مدیریت نمایند.
          </p>

          <h3 className="mt-4">استخرها و پارک های آبی:</h3>
          <p>
            <Link style={{ color: Color.blueSlider }} to="/pool">
              رزرو استخر و پارک های آبی
            </Link>{" "}
            را به راحتی انجام دهید و برنده جایزه های ویژه نیکوتن شوید.
          </p>
          <p style={{ fontWeight: "400" }}>
            شما از طریق نیکوتن به راحتی می توانید تمامی شیفت های مختلف استخرها و
            پارک های آبی سراسر کشور را مشاهده کنید و به راحتی آن ها را با تخفیف
            های ویژه رزرو نمایید. مدیران استخرها هم می توانند به صورت کاملا
            رایگان از سیستم مدیریت آنلاین نیکوتن استفاده کنند و اطلاعات کاربران
            خود را ثبت نمایند.
          </p>
          <div style={{ display: reacdMore ? "block" : "none" }}>
            <h3>باشگاه های بدنسازی:</h3>
            <p style={{ fontWeight: "400" }}>
              یکی از کمبودهایی که در سطح کشور حس می شد سایت جامع برای معرفی،
              اطلاع رسانی و{" "}
              <Link to={"/gym"} style={{ color: Color.primary }}>
                رزرو باشگاه های بدنسازی
              </Link>{" "}
              در کشور بود. از طرفی وجود سیستم های مدیریتی متنوع باعث شده بود
              مدیران باشگاه های بدنسازی هزینه های زیادی انجام دهند. نیکوتن پس از
              نیازسنجی از ورزشکاران و مدیران باشگاه های بدنسازی پنل جامعی را در
              اختیار مدیران باشگاه ها قرار داده است و از طرفی امکان رزرو
              آنلاین(همراه با تخفیف های ویژه و تنضمین بهترین قیمت) را برای
              ورزشکاران نیز فراهم کرد. هم اکنون در نیکوتن بیش از 450 باشگاه
              بدنسازی ثبت شده است که می توانید با مشاهده شیفت های آن ها در
              باشگاه دلخواه خود به صورت آنلاین ثبت نام نمایید.
            </p>
            <h3>سالن های ورزشی:</h3>
            <p style={{ fontWeight: "400" }}>
              معرفی، اطلاع رسانی و
              <Link to={"/pool"} style={{ color: Color.yellow }}>
                {` رزرو آنلاین سالن های ورزشی `}
              </Link>
              کشور اولین بخشی که در سامانه نیکوتن راه اندازی شد. دیگر نیاز نیست
              برای رزرو سالن های ورزشی مورد نظر خود با چندین شماره تماس بگیرید.
              فقط کافی است وارد اپلیکیشن نیکوتن شوید و به راحتی سانس مورد نظر
              خود را انتخاب و رزرو نمایید.
            </p>
            <h3>رزرو قراردادی:</h3>
            <p style={{ fontWeight: "400" }}>
              یکی از امکاناتی که در نسخه جدید به سایت و اپلیکیشن نیکوتن اضافه
              شد، رزرو قراردادی سالن های ورزشی بود. از این پس ورزشکاران گرامی می
              توانند سانس های مورد نظر خود را به صورت قراردادی رزرو نمایند و از
              تخفیفات ویژه نیکوتن استفاده نمایند.
            </p>
            <h3>کلاس های ورزشی:</h3>
            <p style={{ fontWeight: "400" }}>
              دیگر نیاز نیست نگران اوقات فراغت خود یا فرزندانتان باشید. کافی است
              از قسمت کلاس های ورزشی نیکوتن به صورت کاملا آنلاین کلاس های ورزشی
              شهر خودتان را ببینید و به صورت کاملا آنلاین در این کلاس ها ثبت نام
              نمایید. ضمنا می توانید از طریق اینستاگرام نیکوتن معرفی مجموعه ها
              را به راحتی مشاهده کنید و از همه زودتر از تخفیف های نیکوتن باخبر
              شوید. ما در نیکوتن سعی داریم بهترین خدمات را در زمینه اطلاع رسانی،
              معرفی و رزرو آنلاین مجموعه ها و کلاس های ورزشی ارائه دهیم و همواره
              تلاش می کنیم رضایت حداکثری ذینفعان خود(ورزشکاران، مدیران و مربیان)
              را کسب کنیم.
            </p>
            <h3>خدمات نیکوتن:</h3>
            <p style={{ fontWeight: "400" }}>
              <ol>
                <li>خدمات نوبت دهی برای مراکز ورزشی و باشگاه ها</li>
                <li>خدمات نوبت دهی برای مربیان</li>
                <li>خدمات نوبت گیری برای ورزشکاران</li>
                <li>
                  خدمات ارزیابی و نظارت برای ورزشکاران، مربیان و باشگاه ها
                </li>
                <li>خدمات برنامه ریزی ورزشی برای ورزشکاران</li>
                <li>
                  خدمات همیارورزشی و پیوندسازی بین استعدادها و ورزشکاران جهت تیم
                  سازی و یا اشتراک گذاری تجربیات
                </li>
                <li>خدمات تامین و تجهیز ذینفعان</li>
                <li>خدمات معرفی و اطلاع رسانی مجموعه ها و کلاس های ورزشی</li>
              </ol>
            </p>
            <h3>اهداف نیکوتن:</h3>
            <p style={{ fontWeight: "400" }}>
              <ol>
                <li>پیوند بین ورزشکاران، مربیان و مجموعه های ورزشی</li>
                <li>
                  آسان سازی فرآیند نوبت دهی سالن های ورزشی، باشگاه ها، استخرها و
                  مربیان برای ورزشکاران
                </li>
                <li>بهبود فرآیند استعدادیابی،راهنمایی و نظارت بر ورزشکاران</li>
                <li>فراهم آوردن امکان تبادل تجربیات بین ذینفعان</li>
                <li>
                  فراهم آوردن امکان ارزیابی مربیان، مراکز ورزشی و باشگاه ها از
                  سوی ذینفعان
                </li>
                <li>فراهم کردن امکان نظارت و ارزیابی روند پیشرفت ورزشکار</li>
                <li>ایجاد بستری برای آشنایی و ایجاد تعامل بین ذینفعان</li>
                <li>
                  پایبندی به ارزش های اجتماعی و ترویج ارزش های انسانی در زمینه
                  ورزش
                </li>
                <li>بهبود سلامت اجتماعی در سطح کشور</li>
              </ol>
            </p>
          </div>
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <hr
            style={{
              color: "black",
              height: "1px",
              width: "30%",
            }}
          />
          <button
            className="btn"
            onClick={() => {
              setReacdMore(!reacdMore);
            }}
          >
            {reacdMore ? (
              <>
                {" "}
                کمتر <MdExpandLess />
              </>
            ) : (
              <>
                {" "}
                بیشتر <MdOutlineExpandMore />
              </>
            )}
          </button>
          <hr
            style={{
              color: "black",
              height: "1px",
              width: "30%",
            }}
          />
        </div>
      </div>
    </section>
  );
}

export default TwoSliders;
